module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/unox_headquarter-ca901f7d5f17fb1aa4237f3f82529e0f.jpeg";